export default {
    props: {
        email: {type: String, default: ""},
        // what the fields show, when it differs from the state: a logged in customer's
        // CRM e-mail; the national part of a phone number whose country code is on the selector
        displayEmail: {type: String, default: null},
        displayPhone: {type: String, default: null},
        userData: {type: Object, default: () => ({})},
        showLoginFields: {type: Boolean, default: false},
        firstNameError: {type: Boolean, default: false},
        lastNameError: {type: Boolean, default: false},
        phoneError: {type: Boolean, default: false},
        emailError: {type: Boolean, default: false},
        emailMistake: {type: Boolean, default: false},
        isInputLoding: {type: Boolean, default: false},
        loadingFieldName: {type: String, default: ""},
        labels: {type: Object, default: () => ({})},
    },
    emits: ["update:email", "check-email", "update", "phone-change"],
    template: `
        <div class="cart-customer-data">
            <div class="pure-u-1-2">
                <div class="form-group" :class="{error:firstNameError}">
                    <label for="firstname">{{ labels.firstName }}</label>
                    <input id="firstname" :value="userData.firstName" @input="$emit('update', {firstName: $event.target.value})" type="text" autocomplete="given-name" aria-required="true" :aria-invalid="firstNameError ? 'true' : 'false'" :aria-describedby="firstNameError ? 'user-firstname-error' : null">
                </div>
            </div>
            <div class="pure-u-1-2">
                <div class="form-group" :class="{error:lastNameError}">
                    <label for="lastname">{{ labels.lastName }}</label>
                    <input id="lastname" :value="userData.lastName" @input="$emit('update', {lastName: $event.target.value})" type="text" autocomplete="family-name" aria-required="true" :aria-invalid="lastNameError ? 'true' : 'false'" :aria-describedby="lastNameError ? 'user-lastname-error' : null">
                </div>
            </div>
            <div class="pure-u-1-1 pure-u-sm-1-2">
                <div class="form-group" :class="{error:emailError}">
                    <label for="email">{{ labels.email }}</label>
                    <input id="email" type="email" :value="displayEmail ?? email" @input="$emit('update:email', $event.target.value)" :class="{ loading: isInputLoding && loadingFieldName == 'email' }" autocomplete="email" aria-required="true" :aria-invalid="emailError ? 'true' : 'false'" :aria-describedby="[emailError ? 'user-email-error' : '', emailMistake ? 'user-email-hint' : ''].join(' ').trim() || null">
                </div>
            </div>
            <div class="pure-u-1-1 pure-u-sm-1-2">
                <div class="form-group" :class="{error:phoneError}">
                    <label for="phone-cart" class="sr-only">{{ labels.phone }}</label>
                    <input type="tel" id="phone-cart" :placeholder="labels.phone" :value="displayPhone ?? userData.phoneNumber" @input="$emit('phone-change', $event.target.value)" autocomplete="tel" aria-required="true" :aria-invalid="phoneError ? 'true' : 'false'" :aria-describedby="phoneError ? 'user-phone-error' : null">
                </div>
            </div>
        </div>
    `,
};
